module.exports = __webpack_public_path__ + "static/img/bzfh.f24ec5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bzfh.jpg
// module id = Vu0M
// module chunks = 1